import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useGetReportResultLinkMutation } from '../../graphql/mutations/getReportResultLink.generated';
import { ContentSection } from '../../components/Layout/ContentSection';

export const DownloadReportPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const reportFileKey = urlParams.get('report_file_key');

  const [downloadUrl, setDownloadUrl] = useState('');
  const [getReportResultLink, { loading, error }] =
    useGetReportResultLinkMutation();

  useEffect(() => {
    if (reportFileKey) {
      getReportResultLink({
        variables: {
          report_file_key: reportFileKey,
        },
      }).then((result) => {
        if (window && result.data && result.data.getReportResultLink) {
          setDownloadUrl(result.data.getReportResultLink);
          const openedWindow = window.open(
            result.data.getReportResultLink,
            '_blank',
          );
          if (openedWindow) {
            openedWindow.focus();
          }
        } else {
          console.error('Could not get report result link');
          setDownloadUrl('');
        }
      });
    }
  }, [reportFileKey]);

  if (loading) return <div>Loading...</div>;
  if (error)
    return <div>Error - could not fetch download link: {error.message}</div>;

  return (
    <ContentSection title="Download Report" collapsable={false}>
      <a href={downloadUrl} target="_blank">
        <Button color="primary" disabled={!downloadUrl}>
          Download report
        </Button>
      </a>
    </ContentSection>
  );
};
